export function clear(key: string): Promise<void> {
  return new Promise(resolve => {
    window.localStorage.removeItem(key);
    resolve();
  });
}

export function load(key: string, defaultValue: any = null): Promise<any> {
  return new Promise(resolve => {
    const data = window.localStorage.getItem(key);
    resolve(data === null ? defaultValue : JSON.parse(data));
  });
}

export function save(key: string, data: any): Promise<void> {
  return new Promise(resolve => {
    window.localStorage.setItem(key, JSON.stringify(data));
    resolve();
  });
}

export function getLocalItem(key:string) {
  return JSON.parse(localStorage.getItem(key) || '[]');
}
